import React from 'react';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoImg from 'eco-design/base/eco-img';
import BaseDialog, { BaseDialogProps } from '../BaseDialog';
import style from './index.module.scss';
import { useLang } from '@/i18n';
import EcoSection from 'eco-design/base/eco-section';

interface Dialog3Props extends BaseDialogProps {}

const Dialog3: React.FC<Dialog3Props> = (props) => {
    const { t } = useLang('theProduct.SectionJ.item3_dialog');
    return (
        <BaseDialog className={style.comp} {...props}>
            <EcoSection title={t('title')} desc={t('desc')} />
            <EcoSpaceSmall />
            <div className="list">
                <div className="item">
                    <div className="item-title">{t('item1_title')}</div>
                    <div className="item-desc">{t('item1_desc')}</div>
                </div>
                <div className="item">
                    <div className="item-title">{t('item2_title')}</div>
                    <div className="item-desc">{t('item2_desc')}</div>
                </div>
            </div>
            <div className="imgs">
                <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1744767856099/JD3-1.jpg" />
                <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1744767856327/JD3-2.jpg" />
            </div>
        </BaseDialog>
    );
};
export default Dialog3;
